import 'es6-promise/auto'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate from 'vee-validate'

import store from '@/store/index'
import BaseDate from '@/components/BaseDate'
import App from './App'
import router from './router'

// Webflow should load accross the app
// Include only the parts we need from jQuery
// http://alexomara.com/blog/webpack-and-jquery-include-only-the-parts-you-need/
// const $ = require('jquery/src/core');
// Include all of jquery for now until we can figure out what we can remove / exclude
require('jquery/src/jquery')
// require('imports?$=jquery!./ta-intranet.js');
// require('../static/js/webflow');

Vue.config.productionTip = false

Vue.component('BaseDate', BaseDate)

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
})
const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// If running inside Cypress
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`
  window.__app__ = app
}
